"use strict";

define('service/finder',['appkit/service', 'underscore', 'backbone', 'marionette', 'handlebars', 'model/document', 'model/person', 'libs/format/template', 'view/finder.overlay', 'uikit/uikit', 'uikit/collections/container', 'uikit/modules/modal', 'uikit/elements/button', 'uikit/modules/token.input', '../templates'], function (Service, _, Backbone, Mn, Handlebars, Document, Person, templateFormatter, FinderOverlay, UIKit, Container, ModalView, ButtonView, TokenInputView, Templates) {
  var DOCUMENT_COLUMNS = [{
    text: 'IRB#',
    data: 'studyLabel'
  }, {
    text: 'Submission',
    childView: UIKit.Header.extend({
      tagName: 'h5'
    }),
    childBindings: {
      text: 'studyTitle',
      subText: 'templateType'
    }
  }, {
    text: 'PI',
    data: 'principalInvestigator'
  }];
  var FinderService = Service.extend({
    replies: {
      'person:finder': 'personFinder',
      'personFinderOverlay': 'personFinder',
      'submissionFinderOverlay': 'submissionFinder',
      'boardSubmissionFinderOverlay': 'boardSubmissionFinder'
    },
    boardSubmissionFinder: function boardSubmissionFinder(options) {
      var submissionFinder = this.buildBoardSubmissionFinder(options);
      var overlay = this.channel.request('show:overlay', submissionFinder);
      overlay.buttonType = 'save';
      overlay.cancelable = true;
      overlay.header.text = options.text || 'Find Submissions';
      overlay.subHeader.text = '';
      submissionFinder.listenTo(app.overlay, 'shown', _.debounce(function () {
        submissionFinder.searchList.searchView.focus();
      })).listenToOnce(app.overlay, 'save', function () {
        submissionFinder.triggerMethod('save', submissionFinder.addedList.collection.models);
      });
      return submissionFinder;
    },
    submissionFinder: function submissionFinder(options) {
      var submissionFinder = this.buildSubmissionFinder(options);
      var overlay = this.channel.request('show:overlay', submissionFinder);
      overlay.buttonType = 'save';
      overlay.header.text = options.text || 'Find Submissions';
      overlay.subHeader.text = '';
      submissionFinder.listenTo(overlay, 'shown', _.debounce(function () {
        submissionFinder.searchList.searchView.focus();
      })).listenToOnce(overlay, 'save', function () {
        submissionFinder.triggerMethod('save', submissionFinder.addedList.collection);
      });
      return submissionFinder;
    },
    personFinder: function personFinder(options) {
      var personFinderOverlay = this.buildPersonFinder(options);
      var overlay = this.channel.request('show:overlay', personFinderOverlay);
      overlay.buttonType = 'save';
      overlay.cancelable = true;
      overlay.header.text = options.text || 'Find People';
      overlay.subHeader.text = '';
      personFinderOverlay.listenTo(overlay, 'shown', _.debounce(function () {
        personFinderOverlay.searchList.searchView.focus();
      })).listenToOnce(overlay, 'save', function () {
        personFinderOverlay.triggerMethod('save', personFinderOverlay.addedList.collection.models);
      });
      return personFinderOverlay;
    },
    buildPersonFinder: function buildPersonFinder(options) {
      var personFinderOverlay = new FinderOverlay(_.extend({
        headerText: 'Added Members',
        entityName: 'person',
        allTermsMatch: true,
        columns: [{
          data: 'displayName',
          text: 'Name'
        }, {
          data: 'organization',
          text: 'Organization'
        }, {
          data: 'email',
          text: 'Email'
        }, {
          data: 'phone',
          text: 'Phone'
        }],
        srcCollection: Person.allFinder()
      }, options));
      return personFinderOverlay;
    },
    buildSubmissionFinder: function buildSubmissionFinder(options) {
      options = options || {};
      var submissionFinder = new FinderOverlay(_.extend({}, options, {
        headerText: 'Added Submissions',
        entityName: 'document',
        columns: DOCUMENT_COLUMNS,
        srcCollection: Document.submissions(true).addAdapter({
          preprocess: function preprocess(data) {
            data.role = 'ROLE_IRB_ADMIN';
            data.sort = 'activityDate';
            data['sort.dir'] = 'desc';
            data.size = 10;
            if (options.reviewType) {
              data.reviewType = options.reviewType;
            }
            if (options.status) {
              data.status = options.status;
            }
          }
        })
      }));
      return submissionFinder;
    },
    buildBoardSubmissionFinder: function buildBoardSubmissionFinder(options) {
      options = options || {};
      return new FinderOverlay(_.extend({}, options, {
        headerText: 'Added Submissions',
        entityName: 'document',
        localQuery: true,
        columns: DOCUMENT_COLUMNS,
        loadAllImmediately: true,
        srcCollection: Document.submissionsByBoard(options.boardId, options.reviewType)
      }));
    }
  });
  return FinderService;
});

